import { render, staticRenderFns } from "./SimulationVariantEditor.vue?vue&type=template&id=87a5e62a&scoped=true&"
import script from "./SimulationVariantEditor.vue?vue&type=script&lang=js&"
export * from "./SimulationVariantEditor.vue?vue&type=script&lang=js&"
import style0 from "./SimulationVariantEditor.vue?vue&type=style&index=0&id=87a5e62a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a5e62a",
  null
  
)

export default component.exports